import { takeEvery, put, all } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';
import queryStringify from '../../tools/query-stringify';
import httpStatusCodes from '../../constants/http-status-codes';

import * as types from '../../actions/school-admin/question-pool/types';
import * as actions from '../../actions/school-admin/question-pool';

function* getSchoolAdminQuestions({ schoolId, questionType, queryParams }) {
  yield put(actions.setLoading(true, questionType));

  try {
    const { data } = yield apiFetcher.auth().get(
      `schools/${schoolId}/questions-pool/${questionType}?${queryStringify({
        ...queryParams
      })}`
    );

    yield put(actions.setSchoolAdminQuestionsQueryParams(queryParams));
    yield put(actions.setSchoolAdminQuestions(data, questionType));
  } catch (exception) {
    handleError(
      exception,
      `Failed to load school ${questionType} questions from question pool.`
    );
  }

  yield put(actions.setLoading(false, questionType));
}

function* setSchoolAdminQuestionActivationState({
  schoolId,
  questionType,
  questionId,
  state,
  queryParams
}) {
  yield put(actions.setQuestionActivationLoading(true));

  let activationStateName = 'deactivate';
  if (state) {
    activationStateName = 'activate';
  }

  try {
    yield apiFetcher
      .auth()
      .put(
        `schools/${schoolId}/questions-pool/${questionType}/${questionId}/active`,
        { active: state }
      );

    yield put(
      actions.getSchoolAdminQuestions(schoolId, questionType, queryParams)
    );
    yield put(actions.setSchoolAdminQuestionsQueryParams(queryParams));

    toastr.success(
      `The question was successfully ${state ? 'activated' : 'deactivated'}.`
    );
  } catch (exception) {
    if (exception.response) {
      switch (exception.response.status) {
        case httpStatusCodes.Conflict:
          handleError(exception, `Failed to ${activationStateName} question. There is an active question with such text.`);
          break;
        default:
          handleError(exception, `Failed to ${activationStateName} question.`);
          break;
      }
    }
  }

  yield put(actions.setQuestionActivationLoading(false));
}

export default function* schoolAdminQuestionPoolSaga() {
  yield all([
    takeEvery(
      types.SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTION_ACTIVATION_STATE,
      setSchoolAdminQuestionActivationState
    ),
    takeEvery(
      types.SCHOOL_ADMIN_QUESTION_POOL_GET_QUESTIONS,
      getSchoolAdminQuestions
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/school-admin/question-pool.js